<template>
  <div class="barra-pos" :style="estilo" tabindex="-1" aria-live="off">
    <v-icon small class="primary--text text--darken-2 barra-pos-icono">mdi-bullhorn-outline</v-icon>
    <span class="barra-pos-texto">{{ campania.titulo }}</span>
    <a class="barra-pos-ver primary--text text--darken-2" tabindex="-1" data-test="barra-ver" @click.prevent="ir">
      {{ campania.boton_texto || "Ver" }}
    </a>
    <v-btn icon x-small tabindex="-1" aria-label="Cerrar" data-test="barra-cerrar" @click="cerrar">
      <v-icon small>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { abrirEnlaceCampania } from "@/utils/publicidadEnlace";

/**
 * Aviso discreto del POS: una barra fija de 40px al pie de la pantalla. Es lo único
 * que la publicidad puede mostrar en la ruta de venta. Nunca toma el foco (el lector
 * de códigos escribe en el buscador) ni intercepta el teclado.
 */
export default {
  name: "BarraPos",
  props: {
    campania: { type: Object, required: true },
  },
  computed: {
    estilo() {
      const izquierda = (this.$vuetify && this.$vuetify.application && this.$vuetify.application.left) || 0;
      return { left: `${izquierda}px` };
    },
  },
  mounted() {
    this.$store.dispatch("publicidad/verVista", this.campania.id);
  },
  methods: {
    ir() {
      this.$store.dispatch("publicidad/clic", this.campania.id);
      abrirEnlaceCampania(this.campania.boton_url);
    },
    cerrar() {
      this.$store.dispatch("publicidad/cerrar", this.campania.id);
    },
  },
};
</script>

<style scoped>
.barra-pos {
  position: fixed;
  bottom: 0;
  right: 0;
  height: 40px;
  /* Debajo de los diálogos de Vuetify (200+) y del drawer (6) no importa: no se solapan */
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px 0 16px;
  background: #ffffff;
  border-top: 1px solid #e0e0e0;
  outline: none;
  transition: left 0.2s ease;
}
.barra-pos-icono {
  flex-shrink: 0;
}
.barra-pos-texto {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.87);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.barra-pos-ver {
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  flex-shrink: 0;
}
</style>
